module.exports = __webpack_public_path__ + "img/el-icon-setting.svg";